module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isMatch) ? _c('a', {
    staticClass: "btn-download",
    attrs: {
      "href": "https://oss-public.allfootballapp.com/resource/c23670f39a9238a1a1f4c79bd15f7a6a.apk"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.jumpUrl($event)
      }
    }
  }, [_vm._v("Download All Football for more matches")]) : _vm._e(), _vm._v(" "), (_vm.isArticle) ? _c('a', {
    staticClass: "btn-download",
    attrs: {
      "href": "https://oss-public.allfootballapp.com/resource/c23670f39a9238a1a1f4c79bd15f7a6a.apk"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.jumpUrl($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('downloadForComments')))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18df9fc8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/downloadFooter.vue
// module id = 549
// module chunks = 1 3 6 7